import { render, staticRenderFns } from "./ClientOne.vue?vue&type=template&id=b13c754c&"
import script from "./ClientOne.vue?vue&type=script&lang=js&"
export * from "./ClientOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports